import { Box, Divider, Flex, Stack, Switch, Text } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';
import { Fragment } from 'react';
import type { ChangeEvent } from 'react';

import { Type } from './constants';

type MarketingChannel = Type.MARKETING_EMAIL | Type.MARKETING_KAKAO | Type.MARKETING_SMS;

type Props = {
  statuses: Record<MarketingChannel, boolean>;
  onChange: (type: MarketingChannel, status: boolean) => void;
  loading: boolean;
};

export const MarketingChannelSetting = ({ statuses, onChange, loading }: Props) => {
  const { t } = useTranslation();

  const channels: { type: MarketingChannel; label: string }[] = [
    { type: Type.MARKETING_EMAIL, label: t('이메일') },
    { type: Type.MARKETING_KAKAO, label: t('카카오톡') },
    { type: Type.MARKETING_SMS, label: t('문자') },
  ];

  return (
    <Stack gap={20} p={24} bg="gray.0" styles={{ root: { borderRadius: 16 } }}>
      <Box>
        <Text fw={700} fz={16} mb={4}>
          {t('인프런 소식 및 홍보')}
        </Text>
        <Text fz={14} c="gray.6">
          {t('할인, 이벤트, 강의추천 등 유용한 정보를 알려주는 소식을 받을 수 있어요.')}
        </Text>
      </Box>
      <Stack gap={16}>
        {channels.map(({ type, label }, index) => (
          <Fragment key={type}>
            {index > 0 && <Divider size="xs" />}
            <Flex justify="space-between" align="center">
              <Text fw={600} fz={14} c="gray.7">
                {label}
              </Text>
              {loading ? null : (
                <Switch
                  checked={statuses[type]}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    onChange(type, event.target.checked);
                  }}
                  size="md"
                  aria-label={label}
                />
              )}
            </Flex>
          </Fragment>
        ))}
      </Stack>
    </Stack>
  );
};
